import { Show } from "shared/components";
import { MappedIncome } from "../types/income";
import { toMoney } from "shared/utils";
import { DateTime } from "luxon";

export const NetIncomeAnalysisExpandedRow = ({
  original
}: {
  original: MappedIncome;
}) => {
  return (
    <div className="bg-background-900 border-t border-alpha-100 px-5">
      {original.income
        .toSorted(
          (a, b) => new Date(a.month).getTime() - new Date(b.month).getTime()
        )
        .map((i, iIdx) => {
          return (
            <div
              key={iIdx}
              className="border-l !text-sm border-content-100 border-dashed h-[72px] flex items-center w-full relative"
            >
              {/* is Last idx */}
              <Show if={iIdx === original.income.length - 1}>
                <div className="bg-background-900 w-1 h-9 absolute -left-0.5 translate-y-1/2" />
              </Show>
              <div className="flex items-center w-full">
                <div className="flex items-center shrink-0">
                  <div className="w-6 border-t border-content-100 border-dashed h-px" />
                  <div className="bg-content-100 h-1.5 w-1.5 rounded-full" />
                </div>

                <p className="ml-3 text-sm font-medium w-[140px]">
                  {DateTime.fromISO(i.month).toFormat("MMM d, yyyy")}
                </p>

                <div className="flex justify-between items-center ml-4 flex-1">
                  <p className="flex items-center gap-2">
                    <span
                      className="rounded-full block h-2 w-2 shrink-0"
                      style={{
                        backgroundColor: i.color
                      }}
                    ></span>
                    {i.company}
                  </p>
                  <p>{toMoney(i.income)}</p>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};
